module.exports = __webpack_public_path__ + "assets/fla.png";